var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 12,
    height: 14,
    rx: 2,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5H16V12C16 13.1046 15.1046 14 14 14H6C4.89543 14 4 13.1046 4 12V10.5Z",
    fill: "url(#paint0_linear_3640_14271)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 6,
    height: 3.5,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3.5,
    width: 6,
    height: 3.5,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C4 0.895431 4.89543 0 6 0H10V3.5H4V2Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.5,
    width: 6,
    height: 3.5,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 6,
    height: 3.5,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5C4 4.84315 5.34315 3.5 7 3.5C8.65685 3.5 10 4.84315 10 6.5V9.5C10 11.1569 8.65685 12.5 7 12.5H4V6.5Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 2.5,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint1_linear_3640_14271)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5L5.09107 6.95L6.43814 4.5H5.33849L4.50687 6.06429L3.689 4.5H2.55498L3.90893 6.95L2.5 9.5H3.59966L4.48625 7.84286L5.36598 9.5H6.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3640_14271",
    x1: 4,
    y1: 12.25,
    x2: 16,
    y2: 12.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3640_14271",
    x1: 0,
    y1: 7,
    x2: 9,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/ExportIcon.cbc54407db0a9e1ae4081a78441db958.svg";
export { ForwardRef as ReactComponent };